// Material-UI
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Container from '@mui/material/Container';
import ProductCardsCarouselSkeleton from './ProductCardsCarouselSkeleton';

const ProductCarouselsSkeleton = ({ page, isAuthenticated = true }: { page: string; isAuthenticated: boolean }) => {
  return (
    <Container maxWidth="xl" sx={{ my: 2, px: { xs: 0, sm: 3 } }}>
      <Box sx={{ mt: page === 'cart' ? 1 : 2 }}>
        <Box
          display="flex"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
          sx={{
            ml: { xs: 1, sm: 0 },
            flexDirection: { xs: 'column', sm: 'row' },
            mb: { xs: 0.5, md: 0 },
          }}
        >
          {/* title */}
          <Box
            sx={{
              ml: {
                sm: '5px',
              },
              maxWidth: {
                xs: '253px',
                md: '314px',
              },
              width: '100%',
            }}
          >
            <Skeleton variant="rounded" width="100%" sx={{ height: { xs: 24, md: 32 } }} />
          </Box>

          {/* Right side 'View All' skeleton */}
          {isAuthenticated && (
            <Box
              display={{ xs: 'none', md: 'block' }}
              sx={{
                width: '53px',
                height: '20px',
                mr: { xs: 2.825, xl: '65px' },
              }}
            >
              <Skeleton variant="text" height="100%" width="100%" />
            </Box>
          )}
        </Box>

        {/* carousel */}
        <ProductCardsCarouselSkeleton isAuthenticated={isAuthenticated} page={page} />

        {/* view all */}
        <Box display="flex" alignItems="center" justifyContent="center">
          {isAuthenticated && (
            <Box
              sx={{
                mr: 0,
                mt: '-10px',
                display: { xs: 'block', md: 'none' },
              }}
            >
              <Skeleton height={27.5} width={100} />
            </Box>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default ProductCarouselsSkeleton;
